module.exports = __webpack_public_path__ + "img/logo-servel.99e726bf.png";